import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import type { Auth0ProviderOptions } from '@auth0/auth0-react';

import Content from './Content';
import { AppProvider } from '../shared';
import { UserProvider } from '../shared';
import { Notifications } from '../shared';

// auth0-config.js
export const auth0Config: Auth0ProviderOptions = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_AUTH_CLIENT,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: `https://${process.env.REACT_APP_AUTH_DOMAIN}/api/v2/`,
    scope: 'read:current_user update:current_user_metadata offline_access',
  },
};

const App: React.FC = () => {
  return (
    <>
      <Notifications />
      <Auth0Provider
        useRefreshTokens
        domain={auth0Config.domain}
        cacheLocation="localstorage"
        clientId={auth0Config.clientId}
        authorizationParams={auth0Config.authorizationParams}
      >
        <UserProvider>
          <AppProvider>
            <BrowserRouter>
              <Content />
            </BrowserRouter>
          </AppProvider>
        </UserProvider>
      </Auth0Provider>
    </>
  );
};

export default App;
